<template>
    <card>
       <template slot="header">
          <h3 class="card-title">WFH Responsibilities Record</h3>
       </template>
       <div class="row">
          <div class=" col-md-6">
            <nav class="row">
                <ol class="breadcrumb arr-right bg-breadcrum">
                   <li class="breadcrumb-item">
                      <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                   </li>
                   <li class="breadcrumb-item">
                      <router-link to="/hr/responsibilityform">Office Responsibilities</router-link>
                   </li>
                   <li class="breadcrumb-item active">WFH Responsibility</li>
                </ol>
             </nav>
          </div>
          <hr style="margin-top:-10px"/>
      
       </div>
       <hr style="margin-top:-10px"/>
       <div class="row">
          <div class="col-md-12">
             <p><i class="fa fa-search"></i> Search Employee</p>
             <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
          </div>
       </div>
       <hr/>
       <div class="table-responsive ">
          <table class="table table-striped table-hover" v-loading="loading">
             <thead>
                <tr>
                   <th width="10"></th>
                   <th width="700">Employee Name</th>
                   <th width="100">Date Submitted</th>
                   <th width="100">Action</th>
                </tr>
             </thead>
             <tbody>
                <tr v-for="(emp,i) in computedResponsibility">
                   <template v-if="emp === 'no data found'">
                      <td colspan="100%"><h4>  <i class="fa fa-database"></i> Empty Records ...</h4></td>  
                   </template>
                   <template v-else>
                        <td>{{i+1}}</td>
                        <td>{{emp.full_name | capitalize}}</td>
                        <td>{{getDate(emp.created)}}</td>
                        <td>
                           <router-link :to="{name: 'view-wfh-responsibility', params: { id: emp.id }}" class="btn btn-xs btn-default"  v-b-tooltip.hover title="click to view full details of responsibility form"><i class="fa fa-eye"></i>View</router-link>
                        </td>
                   </template>     
                </tr>
             </tbody>
          </table>
       </div>
       <!-- If Lost Connection on Server -->   
       <template v-if="display_indicator === 1">
          <center>
             <br/><br/>
             <img  src="/static/img/warning.png"  width="225" height="190">
             <h1>You've lost your network connection</h1>
             <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
             <br/><br/>
          </center>
       </template>
    </card>
 </template>
     
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    export default {
        components: {
            Card
        },
        data() {
            return {
                items: {},
                search: '',
                loading: true,
                 //Indicator
                display_indicator:''
            }
        },
        mounted: function() {
            this.get_responsibility();
        },
        methods: {
   
            get_responsibility() {
                axios.get('api/wfh/responsibility/hr/get')
                    .then(response => {
                    this.items = response.data;
                    this.display_indicator = 2;
                    this.loading = false;
                    })
                    .catch(error => {
                    console.log(error.response)
                    this.display_indicator = 1;
                    });
            },
            getDate(date) {
                return moment(date).format('MMM DD YYYY');
            },
        },
        computed: {
            computedResponsibility() {
                // SEARCH BY EMPLOYEE FULLNAME
                let filtered = this.items
                  if(filtered.length > 0){
                    if (this.search) {
                        filtered = filtered.filter(
                       item => item.full_name.toLowerCase().indexOf(this.search) > -1
                      );
                      return filtered
                     }
                   }
                return filtered
            }
        },

      
        }
    </script>
   


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/todo-wfh-responsibility.vue